import React from 'react';
import classnames from 'classnames';

import './style.css';

const SatisfactionGuarantee = ({ dark = false }) => (
  <div
    className={classnames('satisfaction-guaranteed mx-auto', {
      dark,
      light: !dark,
    })}
  >
    <div className="d-flex">
      <div className="pl-3 font-weight-bold">
        Learn with 100% satisfaction gurantee
      </div>
      <img
        className={classnames('pl-2', { 'img-shield-white': !dark })}
        src="/assets/shield.png"
        alt="lock"
      />
    </div>
    <div className="pl-3 pt-2 small-text">
      If your lesson does not take place, or you are not satisfied with the
      teacher, we will offer you a full credit refund to book another lesson
      with a different teacher.
    </div>
  </div>
);

export default SatisfactionGuarantee;



// WEBPACK FOOTER //
// ./src/components/SatisfactionGuarantee/index.js